import { filterChipText, withFilterApplied, withFilterCleared, type Column, type Filter, type FilterType } from './OtuDataTableView.logic.js'

/** A one-click filter chip: [field] compared against [value] with [filterType]. */
export type ReductionPreset = { field: string; filterType: FilterType; value: string }

const atLeast = (field: string, value: number): ReductionPreset => ({
  field,
  filterType: 'GREATER_THAN_OR_EQUAL',
  value: String(value)
})

/** The reductions offered next to the active filters; none is applied by default. */
export const REDUCTION_PRESETS: readonly ReductionPreset[] = [
  atLeast('gradePercentage', 97),
  atLeast('gradePercentage', 95),
  atLeast('gradePercentage', 90),
  atLeast('totalRawReads', 10),
  atLeast('totalRawReads', 100)
]

const presetFilter = (preset: ReductionPreset): Filter => ({ parameter: preset.field, value: preset.value, filterType: preset.filterType })

/** The preset's button text: the chip it creates reads the same. */
export const presetLabel = (preset: ReductionPreset, columns: readonly Column[]): string => filterChipText(presetFilter(preset), columns)

export const isPresetActive = (filters: Filter[], preset: ReductionPreset): boolean =>
  filters.some((f) => f.parameter === preset.field && f.filterType === preset.filterType && String(f.value) === preset.value)

/** [filters] with [preset]'s chip in place of any filter on its column, or without it when it was already active. */
export const withPresetToggled = (filters: Filter[], preset: ReductionPreset): Filter[] =>
  isPresetActive(filters, preset)
    ? withFilterCleared(filters, preset.field)
    : withFilterApplied(filters, preset.field, preset.value, preset.filterType)
